<ng-template class="theme-modal" #addressModal let-modal>
  <div class="modal-content quick-view-modal">
    <div class="modal-body">
      <button
        type="button"
        class="close"
        (click)="closeAddressModal()"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="address-form">
        <div class="address-header text-center" *ngIf="editAddress">Update Delivery Address</div>
        <div class="address-header text-center" *ngIf="addAddress">Add New Delivery Address</div>
        <div class="address-subheader">
          Please enter the accurate address, it will help us to serve you better
        </div>
        <div class="p-2">
          <form name="addressForm">
            <div class="form-row">
              <div class="form-group col-md-9 col-sm-12">
                <label for="inputEmail4">Area / Locality </label>
                <input type="text" name="inputEmail4" class="form-control" [(ngModel)]="address.locality" placeholder= "Set Location" id="inputEmail4" />
              </div>
              <div class="col-md-3 col-sm-12">
                <button class="btn btn-outline-secondary detectbutton" (click)="detectLocation()">
                  <i class="fa fa-location-arrow"></i> Detect
                </button>
              </div>
            </div>
            <div class="detailssection">
              <div class="form-group">
                <label for="exampleInputEmail1"
                  >Flat / House / Office No.</label
                >
                <input type="text" class="form-control" id="flatNo" name="doorNo" [(ngModel)]="address.doorNo"/>
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1"
                  >Street / Society / Office Name
                </label>
                <input type="text" class="form-control" id="streetNo" name="streetNo" [(ngModel)]="address.landmark"/>
              </div>
              <div class="form-group">
                <label for="city">City</label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="address.city"
                  id="city"
                  name="city"
                />
              </div>
              <div class="form-group">
                <label for="state">State </label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="address.state"
                  name="state"
                  id="state"
                />
              </div>
              <div class="form-group">
                <label for="state">Pincode </label>
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="address.pincode"
                  id="pincode"
                  name="pincode"
                />
              </div>
              <div class="form-group">
                <div class="form-check form-check-inline">
                <input
                  type="checkbox"
                  class="form-check-input"
                  [(ngModel)]="address.defaultAddress"
                  id="defaultAddress"
                  name="defaultAddress"
                />
                <label class="form-check-label" for="defaultAddress"
                    >Set as Default</label
                  >
                </div>
              </div>
              <div class="form-group">
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    (change) = "changeAddressType('Home')"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value="Home"
                    (click) = "showOtherTextBox(false)"
                    [checked] = "address.addressType == 'Home' ? true : false"
                  />
                  <label class="form-check-label" for="inlineRadio1"
                    >Home</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    value = "Office"
                    (change) = "changeAddressType('Office')"
                    (click) = "showOtherTextBox(false)"
                    [checked] = "address.addressType == 'Office' ? true : false"
                  />
                  <label class="form-check-label" for="inlineRadio2"
                    >Office</label
                  >
                </div>
                <div class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    [(ngModel)]="otherType"
                    name="inlineRadioOptions"
                    id="inlineRadio3"
                    value="Other"
                    (click) = "showOtherTextBox(true)"
                  />
                  <label class="form-check-label" for="inlineRadio3"
                    >Other</label
                  >
                </div>
              </div>
              <div class="form-group" *ngIf="showOtherBox">
                <input type="text" class="form-control" id="other" name="other" [(ngModel)]="addressType"/>
              </div>

              <div class="text-center">
                <button
                  type="button"
                  class="btn btn-success next-btn mr-3"
                  style="width: 30%"
                  (click) = "submitAddress()"
                  [disabled]="!address.locality || !address.doorNo || !address.landmark || !address.city || !address.state || !address.pincode"
                >
                  Save
                </button>
                <button
                  type="button"
                  class="btn btn-light next-btn"
                  style="width: 30%"
                  (click)= "closeAddressModal()"
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-template>
